import React from "react"
import { useState, useEffect } from "react";
import { getRequest } from "sharedUtils/httpUtils";
import { QRCodeCanvas } from "qrcode.react";

import TwitterIcon from "components/icons/TwitterIcon";
import FacebookIcon from "components/icons/FacebookIcon";
import MobileShare from "components/MobileShare";
import MailIcon from 'components/icons/MailIcon';
import { getProperties } from "sharedUtils/postFunctions";
import { trimProductsArray } from "sharedUtils/postFunctions";


/** 
 * @param {{loggedInUser: Object, title:string, shareCode:string?, customStyle:Object, shareBlockStyle:Object}} props 
 */
const ShareBlock = (props) => {
    const [qrImage, setQrImage] = useState(null);

    const qrCodeRefCallback = (node) => {
        if (node) {
            const canvas = node.querySelector("canvas");
            if (canvas) {
                setTimeout(() => {
                    const image = canvas.toDataURL('image/png');
                    setQrImage(image);
                }, 200);
            } else {
                console.warn("Canvas not found inside QR Code element.");
            }
        } else {
            console.warn("QR Code ref callback received null (likely unmounted).");
        }
    };

    const [showCopied, setCopiedText] = useState(false);
    const [showCopied2, setCopiedText2] = useState(false);
    const [showCopied3, setCopiedText3] = useState(false);
    const [showCopied4, setCopiedText4] = useState(false);
    const [renderDirect, setRenderDirect] = useState(false);

    const [postEmbedCode, setPostEmbedCode] = useState(null);
    const [lockerEmbedCode, setLockerEmbedCode] = useState(null);
    const [productEmbedCode, setProductEmbedCode] = useState(null);
    const [postEmbedBrandCode, setPostEmbedBrandCode] = useState(null);
    const [blogEmbedCode, setBlogEmbedCode] = useState(null);
    const [lockerEmbedBrandCode, setLockerEmbedBrandCode] = useState(null);
    const [productEmbedBrandCode, setProductEmbedBrandCode] = useState(null);
    const [profileEmbedCode, setProfileEmbedCode] = useState(null);
    const [merchantEmbedCode, setMerchantEmbedCode] = useState(null);
    const [referralShareCode, setReferralShareCode] = useState(null);
    const [shareCode, setShareCode] = useState(null);
    const [shareType, setShareType] = useState("");
    const [emailEmbedCode, setEmailEmbedCode] = useState(null);

    const extractEmbeddedUsernames = (text) => {
        return text.replace(/#!\^.*?@\(\(\((.*?)\)\)\)/g, '@$1');

    }

    const GetPostEmailHtml = async (type) => {
        const html = `<div style="max-width:600px;margin:0 auto;border:1px solid lightgray;border-radius:15px;"><a href="{{{shareLink}}}" style="text-decoration:none;cursor:pointer;" target="_blank"><table align="center" role="presentation" border="0" cellpadding="0" cellspacing="0" style="width:100%;max-width:600px;"><tr><td style="text-align:center;padding:20px 0;"><img src="https://app.rockporch.com/images/rockporch-logo.png" width="162" style="display:block;margin:0 auto;border:0;" alt="Logo" /></td></tr></table><table role="presentation" border="0" cellpadding="0" cellspacing="0" style="width:100%;max-width:600px;"><tr><td style="text-align:center;padding:10px 25px;"><img src="{{{bannerImage}}}" width="550" style="width:100%;max-width:550px;border:0;display:block;object-fit:cover;max-height:500px;" alt="" /></td></tr><!-- Title --><tr><td style="text-align:center;font-family:Helvetica;font-size:24px;color:#000000;padding:0 20px;">{{{title}}}</td></tr><!-- End Title --><!-- Subtitle --><tr><td style="text-align:center;font-family:Helvetica;font-size:15px;color:#000000;padding:10px 20px;">{{{subTitle}}}</td></tr><!-- End Subtitle --><!-- productButton --><tr><td align="center" style="padding:10px 0;"><table role="presentation" cellpadding="0" cellspacing="0" style="border-collapse:separate;line-height:100%;"><tr><td align="center" bgcolor="#d46240" style="opacity:0.8;border-radius:40px;background:#d46240;padding:10px 25px;color:#ffffff;font-family:Helvetica;font-size:12px;">{{{productCount}}}</td></tr></table></td></tr><!-- End productButton --></table><table align="center" role="presentation" border="0" cellpadding="0" cellspacing="0" style="width:100%;max-width:600px;"><tr><td align="center" style="padding:10px 0;"><!--[if mso]><table role="presentation" border="0" cellpadding="0" cellspacing="0"><tr><![endif]--><!-- Product 1 --><table role="presentation" border="0" cellpadding="0" cellspacing="0" align="left" width="100%" style="max-width:190px;display:inline-block;vertical-align:top;margin:0 auto;"><tr><td style="padding:10px;text-align:center;"><div style="margin-left:12px;width:100%;padding:10px;border:1px solid lightgray;border-radius:15px;"><img src="{{{productImage1}}}" width="120" style="display:block;margin:0 auto;max-width:120px;max-height:120px;object-fit:contain;min-width:120px;min-height:120px;" alt="Product 1" /></div></td></tr></table><!-- End Product 1 --><!-- Product 2 --><table role="presentation" border="0" cellpadding="0" cellspacing="0" align="left" width="100%" style="max-width:190px;display:inline-block;vertical-align:top;margin:0 auto;"><tr><td style="padding:10px;text-align:center;"><div style="margin-left:12px;width:100%;padding:10px;border:1px solid lightgray;border-radius:15px;"><img src="{{{productImage2}}}" width="120" style="display:block;margin:0 auto;max-width:120px;max-height:120px;object-fit:contain;min-width:120px;min-height:120px;;" alt="Product 2" /></div></td></tr></table><!-- End Product 2 --><!-- Product 3 --><table role="presentation" border="0" cellpadding="0" cellspacing="0" align="left" width="100%" style="max-width:190px;display:inline-block;vertical-align:top;margin:0 auto;"><tr><td style="padding:10px;text-align:center;"><div style="margin-left:12px;width:100%;padding:10px;border:1px solid lightgray;border-radius:15px;"><img src="{{{productImage3}}}" width="120" style="display:block;margin:0 auto;max-width:120px;max-height:120px;object-fit:cover;min-width:120px;min-height:120px;" alt="Product 3" /></div></td></tr></table><!-- End Product 3 --><!--[if mso]></tr></table><![endif]--></td></tr></table></a></div>`;
        let shareCode = props.shareCode;
        let parsedShareCode = shareCode.slice(shareCode.lastIndexOf("/") + 1);
        if (parsedShareCode.includes("?")) {
            parsedShareCode = parsedShareCode.slice(0, parsedShareCode.indexOf("?"));
        }

        const url = `/api/post/getPost?shareCode=${parsedShareCode}&referrer=null&noTracking=true`;
        const post = await getRequest(url);
        console.log(post);

        if (!post) return '';

        const properties = getProperties(post.properties);

        const bannerImage =
            properties.find(
                (p) =>
                    p?.parentId == null &&
                    (p?.role === 0 || p?.role === 8)
            )?.value || null;

        if (!(bannerImage)) {
            return;
        }

        let title = "";
        let subTitle = "";

        if (type === "post") {
            title = post.content?.trim() || '';
            subTitle = ''; // Posts don't use a subtitle
        } else {
            title = post.title?.trim() || '';
            subTitle = post.content?.trim() || '';
        }

        const products = trimProductsArray(post.productItems?.$values)?.sort(
            (a, b) => a.ordinal - b.ordinal
        ) || [];

        const productImages = products.slice(0, 3).map((p) => p.imageUrl);
        let productCount = "";
        if (products?.length > 1) {
            productCount = products.length + " Products";
        } else if (products.length > 0) {
            productCount = "1 Product";
        }

        let updatedHtml = html
            .replace('{{{shareLink}}}', shareCode) // `shareLink` from state
            .replace('{{{bannerImage}}}', bannerImage)
            .replace('{{{productCount}}}', productCount)
            .replace('{{{title}}}', extractEmbeddedUsernames(title))
            .replace('{{{subTitle}}}', extractEmbeddedUsernames(subTitle));

        // Remove title section if empty
        if (!title) {
            updatedHtml = updatedHtml.replace(
                /<!-- Title -->[\s\S]*?<!-- End Title -->/,
                ''
            );
        }

        // Remove subtitle section if empty
        if (!subTitle) {
            updatedHtml = updatedHtml.replace(
                /<!-- Subtitle -->[\s\S]*?<!-- End Subtitle -->/,
                ''
            );
        }

        // Remove productCount section if empty
        if (!productCount) {
            updatedHtml = updatedHtml.replace(
                /<!-- productButton -->[\s\S]*?<!-- End productButton -->/,
                ''
            );
        }

        // Replace product images
        productImages.forEach((img, index) => {
            updatedHtml = updatedHtml.replace(`{{{productImage${index + 1}}}}`, img);
        });

        // Remove unused product blocks
        for (let i = productImages.length + 1; i <= 3; i++) {
            const regex = new RegExp(
                `<!-- Product ${i} -->[\\s\\S]*?<!-- End Product ${i} -->`,
                'g'
            );
            updatedHtml = updatedHtml.replace(regex, '');
        }

        setEmailEmbedCode(updatedHtml);
    };

    const GetProductEmailHtml = async () => {
        let html = `<div style="max-width:600px;margin:0 auto;border:1px solid lightgray;border-radius:15px;padding-bottom:20px;"><a href="{{{shareLink}}}" style="text-decoration:none;cursor:pointer;" target="_blank"><table align="center" role="presentation" border="0" cellpadding="0" cellspacing="0" style="width:100%;max-width:600px;"><tr><td style="text-align:center;padding:20px 0;"><img src="https://app.rockporch.com/images/rockporch-logo.png" width="162" style="display:block;margin:0 auto;border:0;" alt="Logo" /></td></tr></table><table role="presentation" border="0" cellpadding="0" cellspacing="0" style="width:100%;max-width:600px;"><tr><td style="text-align:center;padding:10px 25px;"><img src="{{{productImage}}}" width="550" style="width:100%;max-width:550px;border:0;display:block;object-fit:cover;max-height:500px;" alt="" /></td></tr><tr><td style="text-align:center;font-family:Helvetica,Arial,sans-serif;font-size:15px;color:#000000;padding:10px 20px;">{{{merchant}}}</td></tr><tr><td style="text-align:center;font-family:Helvetica,Arial,sans-serif;font-size:24px;color:#000000;padding:0 20px;">{{{productName}}}</td></tr></table></a></div>`;
        let shareCode = props.shareCode;
        let parsedShareCode = shareCode.slice(shareCode.lastIndexOf("/") + 1);
        if (parsedShareCode.includes("?")) {
            parsedShareCode = parsedShareCode.slice(0, parsedShareCode.indexOf("?"));
        }
        console.log(shareCode, parsedShareCode)
        if (!(parsedShareCode)) {
            return;
        }

        const url = `/Products/Get?shareCode=${parsedShareCode}&noTracking=true`;
        const product = await getRequest(url);
        console.log(product);

        if (!(product)) return;

        const productImage = product.imageUrl;

        if (!(productImage)) {
            return;
        }

        let merchant = product.merchant;
        let productName = product.name;

        let updatedHtml = html
            .replace('{{{shareLink}}}', shareCode) // `shareLink` from state
            .replace('{{{productImage}}}', productImage)
            .replace('{{{merchant}}}', merchant)
            .replace('{{{productName}}}', productName)

        // Remove title section if empty
        if (!merchant) {
            updatedHtml = updatedHtml.replace(
                /<!-- Merchant -->[\s\S]*?<!-- End Merchant -->/,
                ''
            );
        }

        // Remove subtitle section if empty
        if (!productName) {
            updatedHtml = updatedHtml.replace(
                /<!-- ProductName -->[\s\S]*?<!-- End ProductName -->/,
                ''
            );
        }

        setEmailEmbedCode(updatedHtml);
    };


    useEffect(() => {
        setShareCode(props.shareCode);
        const isBrowse = !!(props.shareCode) && props.shareCode.toLowerCase().includes("b=1");
        const isReferral = !!(props.shareCode) && props.shareCode.toLowerCase().includes("referraluser");

        if (isReferral) {
            setReferralShareCode(props.shareCode)
        }

        let embedHost;
        let parsedShareCode;

        if (props.isUserMerchant) setRenderDirect(props.isUserMerchant);
        if (props.shareCode.includes(".ch/")) {
            embedHost = props.shareCode.slice(0, props.shareCode.indexOf(".ch/") + ".ch/".length)
        } else if (props.shareCode.includes(".com/")) {
            embedHost = props.shareCode.slice(0, props.shareCode.indexOf(".com/") + ".com/".length)
        } else if (props.shareCode.includes("44334/")) {
            embedHost = props.shareCode.slice(0, props.shareCode.indexOf("44334/") + "44334/".length)
        }

        parsedShareCode = props.shareCode.slice(props.shareCode.lastIndexOf("/") + 1);
        if (parsedShareCode.includes("?")) {
            parsedShareCode = parsedShareCode.slice(0, parsedShareCode.indexOf("?"));
        }

        if (props.shareCode?.toLowerCase().includes("/p/") || props.shareCode?.toLowerCase().includes("/plink/")) {
            setShareType("Post");

            let index = props.shareCode.toLowerCase().includes("/p/") ? props.shareCode.toLowerCase().indexOf("/p/") : props.shareCode.toLowerCase().indexOf("/plink/");
            let embedUrl = props.shareCode.slice(0, index) + "/embed" + props.shareCode.slice(index);
            let brandUrl = embedUrl.slice(0, embedUrl.indexOf("/embed") + "/embed".length) + "/brand" + embedUrl.slice(embedUrl.indexOf("/embed") + "/embed".length);
            let iframe = `<iframe id="rpFrame-${parsedShareCode}" src="${embedUrl}" frameborder="0" allowfullscreen="" scrolling="no" style="width:100%;height:770px;min-height:770px;overflow:hidden;"></iframe><script>window.addEventListener('message',function(e){if(e.data&&e.data.id==="rpFrame-${parsedShareCode}"){var t=e.data.height+'px';document.getElementById("rpFrame-${parsedShareCode}").style.height=t;document.getElementById("rpFrame-${parsedShareCode}").style.minHeight=t}},!1);</script>`;
            let brandIframe = `<iframe onload="sendMessage()" id="rpFrame-${parsedShareCode}" src="${brandUrl}" frameborder="0" allowfullscreen style="width:100%;height:100%;min-height:450px;"></iframe><script crossorigin="">function sendMessage(){document.querySelector("#rpFrame-${parsedShareCode}").contentWindow.postMessage("rpMessage","${embedHost}")}window.addEventListener("message",function(e){let isJson=!1;let rpJson;try{rpJson=JSON.parse(e.data);isJson=!0}catch{isJson=!1}if(isJson){if(typeof rpJson.shareCode==="string"){if(typeof rpJson.height==="number"){if(rpJson.height>0){const elements=document.querySelectorAll('iframe[id=rpFrame-'+rpJson.shareCode+']');elements.forEach(element=>{element.style.minHeight=rpJson.height+60+"px"})}}}}})</script>`;
            setPostEmbedCode(iframe);
            setPostEmbedBrandCode(brandIframe);
            GetPostEmailHtml("post");
        } else if (props.shareCode?.toLowerCase().includes("/b/") || props.shareCode?.toLowerCase().includes("/blink/")) {
            setShareType("Blog");

            let index = props.shareCode.toLowerCase().includes("/b/") ? props.shareCode.toLowerCase().indexOf("/b/") : props.shareCode.toLowerCase().indexOf("/blink/");
            let embedUrl = props.shareCode.slice(0, index) + "/embed" + props.shareCode.slice(index);
            let iframe = `<iframe id="rpFrame-${parsedShareCode}" src="${embedUrl}" frameborder="0" allowfullscreen="" scrolling="no" style="width:100%;height:770px;min-height:770px;overflow:hidden;"></iframe><script>window.addEventListener('message',function(e){if(e.data&&e.data.id==="rpFrame-${parsedShareCode}"){var t=e.data.height+'px';document.getElementById("rpFrame-${parsedShareCode}").style.height=t;document.getElementById("rpFrame-${parsedShareCode}").style.minHeight=t}},!1);</script>`;
            setBlogEmbedCode(iframe);
            GetPostEmailHtml();
        } else if (props.shareCode?.toLowerCase().includes("/l/") || props.shareCode?.toLowerCase().includes("/llink/")) {
            setShareType("Locker");

            let index = props.shareCode.toLowerCase().includes("/l/") ? props.shareCode.toLowerCase().indexOf("/l/") : props.shareCode.toLowerCase().indexOf("/llink/");
            let embedUrl = props.shareCode.slice(0, index) + "/embed" + props.shareCode.slice(index);
            let brandUrl = embedUrl.slice(0, embedUrl.indexOf("/embed") + "/embed".length) + "/brand" + embedUrl.slice(embedUrl.indexOf("/embed") + "/embed".length);
            let iframe = `<iframe id="rpFrame-${parsedShareCode}" src="${embedUrl}" frameborder="0" allowfullscreen="" scrolling="no" style="width:100%;height:770px;min-height:770px;overflow:hidden;"></iframe><script>window.addEventListener('message',function(e){if(e.data&&e.data.id==="rpFrame-${parsedShareCode}"){var t=e.data.height+'px';document.getElementById("rpFrame-${parsedShareCode}").style.height=t;document.getElementById("rpFrame-${parsedShareCode}").style.minHeight=t}},!1);</script>`;
            let brandIframe = `<iframe onload="sendMessage()" id="rpFrame-${parsedShareCode}" src="${brandUrl}" frameborder="0" allowfullscreen style="width:100%;height:100%;min-height:450px;"></iframe><script crossorigin="">function sendMessage(){document.querySelector("#rpFrame-${parsedShareCode}").contentWindow.postMessage("rpMessage","${embedHost}")}window.addEventListener("message",function(e){let isJson=!1;let rpJson;try{rpJson=JSON.parse(e.data);isJson=!0}catch{isJson=!1}if(isJson){if(typeof rpJson.shareCode==="string"){if(typeof rpJson.height==="number"){if(rpJson.height>0){const elements=document.querySelectorAll('iframe[id=rpFrame-'+rpJson.shareCode+']');elements.forEach(element=>{element.style.minHeight=rpJson.height+60+"px"})}}}}})</script>`;
            setLockerEmbedCode(iframe);
            setLockerEmbedBrandCode(brandIframe);
            GetPostEmailHtml();
        } else if (props.shareCode?.toLowerCase().includes("/m/") || props.shareCode?.toLowerCase().includes("/mlink/")) {
            setShareType("Merchant");

            addShareSubdomainMerchant(parsedShareCode)

            const embed = `<div><p><a href="${props.shareCode}"><img style="width: auto; max-height: 200px; margin: 0 auto; display: block;" loading="lazy" src="${props.merchantLogoUrl}" alt="" srcset="${props.merchantLogoUrl}"></a></p></div>`;
            setMerchantEmbedCode(embed);
        } else if (props.shareCode?.toLowerCase().includes("/prd/")) {
            setShareType("Product");

            addShareSubdomainProduct(parsedShareCode);
            let index = props.shareCode.toLowerCase().indexOf("/prd/");
            let embedUrl = props.shareCode.slice(0, index) + "/embed" + props.shareCode.slice(index);

            let brandUrl = embedUrl.slice(0, embedUrl.indexOf("/embed") + "/embed".length) + "/brand" + embedUrl.slice(embedUrl.indexOf("/embed") + "/embed".length);
            let iframe = `<iframe src="${embedUrl}" frameborder="0" allowfullscreen style="width:100%;height:100%;min-height:320px;"></iframe>`
            let brandIframe = `<iframe onload="sendMessage()" id="rpFrame-${parsedShareCode}" src="${brandUrl}" frameborder="0" allowfullscreen style="width:100%;height:100%;min-height:450px;"></iframe><script crossorigin="">function sendMessage(){document.querySelector("#rpFrame-${parsedShareCode}").contentWindow.postMessage("rpMessage","${embedHost}")}window.addEventListener("message",function(e){let isJson=!1;let rpJson;try{rpJson=JSON.parse(e.data);isJson=!0}catch{isJson=!1}if(isJson){if(typeof rpJson.shareCode==="string"){if(typeof rpJson.height==="number"){if(rpJson.height>0){const elements=document.querySelectorAll('iframe[id=rpFrame-'+rpJson.shareCode+']');elements.forEach(element=>{element.style.minHeight=rpJson.height+60+"px"})}}}}})</script>`;
            setProductEmbedCode(iframe);
            setProductEmbedBrandCode(brandIframe);
            GetProductEmailHtml();
        } else if (props.shareCode?.toLowerCase().includes("/prdlink/")) {
            setShareType("Product");

            addShareSubdomainProduct(parsedShareCode);
            let index = props.shareCode.toLowerCase().indexOf("/prdlink/");
            let embedUrl = props.shareCode.slice(0, index) + "/embed" + props.shareCode.slice(index);
            embedUrl = embedUrl.replace("/prdlink/", "/prd/");

            let brandUrl = embedUrl.slice(0, embedUrl.indexOf("/embed") + "/embed".length) + "/brand" + embedUrl.slice(embedUrl.indexOf("/embed") + "/embed".length);
            let iframe = `<iframe src="${embedUrl}" frameborder="0" allowfullscreen style="width:100%;height:100%;min-height:320px;"></iframe>`
            let brandIframe = `<iframe onload="sendMessage()" id="rpFrame-${parsedShareCode}" src="${brandUrl}" frameborder="0" allowfullscreen style="width:100%;height:100%;min-height:450px;"></iframe><script crossorigin="">function sendMessage(){document.querySelector("#rpFrame-${parsedShareCode}").contentWindow.postMessage("rpMessage","${embedHost}")}window.addEventListener("message",function(e){let isJson=!1;let rpJson;try{rpJson=JSON.parse(e.data);isJson=!0}catch{isJson=!1}if(isJson){if(typeof rpJson.shareCode==="string"){if(typeof rpJson.height==="number"){if(rpJson.height>0){const elements=document.querySelectorAll('iframe[id=rpFrame-'+rpJson.shareCode+']');elements.forEach(element=>{element.style.minHeight=rpJson.height+60+"px"})}}}}})</script>`;
            setProductEmbedCode(iframe);
            setProductEmbedBrandCode(brandIframe);
            GetProductEmailHtml();
        }

    }, []);

    useEffect(() => {
        setShareCode(props.shareCode);

        if (props.shareCode?.toLowerCase().includes("/prf/")) {
            setShareType("Profile");

            let index = props.shareCode.toLowerCase().indexOf("/prf/");
            let embedUrl = props.shareCode.slice(0, index) + "/embed" + props.shareCode.slice(index);
            let iframe = `<iframe src="${embedUrl}" frameborder="0" allowfullscreen style="width:100%;"></iframe>`
            setProfileEmbedCode(iframe);
        }
        if (props.shareCode?.toLowerCase().includes("/prflink/")) {
            setShareType("Profile");

            let index = props.shareCode.toLowerCase().indexOf("/prflink/");
            let embedUrl = props.shareCode.slice(0, index) + "/embed" + props.shareCode.slice(index);
            embedUrl = embedUrl.replace("/prflink/", "/prf/");

            let iframe = `<iframe src="${embedUrl}" frameborder="0" allowfullscreen style="width:100%;"></iframe>`
            setProfileEmbedCode(iframe);
        }
    }, [props.shareCode]);

    const addShareSubdomainMerchant = async (id) => {
        let route = '/api/Merchant/GetMerchant?id=' + id;
        //
        let merchant = await getRequest(route);

        if (!!(merchant) && window.location.host.toLowerCase().includes("app.rockp") && !!(merchant.shareSubdomain)) {
            let url = new URL(props.shareCode);
            url.hostname = `${merchant.shareSubdomain}.rockporch.com`;
            setShareCode(url.toString());
        }
    };

    const handleGoogleAnalytics4 = () => {
        window.gtag('event', 'Share_Modal_' + shareType, {
            send_to: 'G-9F2DZRE5FG',
            event_category: 'Button',
            event_label: `Share Modal ` + shareType,
        });
    }

    const addShareSubdomainProduct = async (shareCode) => {
        let route = '/api/Merchant/GetMerchantByProductShareCode?shareCode=' + shareCode;

        let merchant = await getRequest(route);

        if (!!(merchant) && window.location.host.toLowerCase().includes("app.rockp") && !!(merchant.shareSubdomain)) {
            let url = new URL(props.shareCode);
            url.port = "";
            url.hostname = `${merchant.shareSubdomain}.rockporch.com`;
            setShareCode(url.toString());
        }
    }

    let renderCopiedText = () => {
        if (showCopied) {
            setTimeout(() => { setCopiedText(false) }, 500);
            return (<i className="fas fa-clipboard-check"></i>);
        }
        return ("Copy");
    }

    let renderCopiedText2 = () => {
        if (showCopied2) {
            setTimeout(() => { setCopiedText2(false) }, 500);
            return (<i className="fas fa-clipboard-check"></i>);
        }
        return ("Copy");
    }

    let renderCopiedText3 = () => {
        if (showCopied3) {
            setTimeout(() => { setCopiedText3(false) }, 500);
            return (<i className="fas fa-clipboard-check"></i>);
        }
        return ("Copy");
    }

    let renderCopiedText4 = () => {
        if (showCopied4) {
            setTimeout(() => { setCopiedText4(false) }, 500);
            return (<i className="fas fa-clipboard-check"></i>);
        }
        return ("Copy");
    }

    if (!!(referralShareCode)) {
        return (

            <div className="col-md-6 text-center" style={props.customStyle}>
                <div className="share-block" style={props.shareBlockStyle}>


                    <h5 className="mb-3">Copy and Send the Personalized Link Below to Refer your Creator Friends to RockPorch</h5>
                    <h6 className="mb-3 font-italic" style={{ fontSize: "14px" }}>Get paid for referring new Creators!</h6>

                    <p className="mb-4" style={{ fontSize: "12px" }}>
                        When you refer a fellow passion-driven Creator to RockPorch, we'll pay you 2.5% of the sales they generate through RockPorch for 12 MONTHS <img style={{ verticalAlign: "top" }} src="/images/flame.png" />
                        <br />
                        <i>(don't worry... it doesn't come out of their commissions!)</i>
                    </p>

                    <div className="clipboard mb-4">
                        <input type="text" disabled defaultValue={referralShareCode} id="myInput" onChange={() => null} />
                        <button className="btn" onClick={() => { navigator.clipboard.writeText(referralShareCode); setCopiedText(true); handleGoogleAnalytics4(); }}>{renderCopiedText()}</button>
                    </div>

                </div>

            </div>
        )
    }

    return (

        <div className="col-md-6 text-center" style={props.customStyle}>
            <div className="share-block" style={props.shareBlockStyle}>


                <h5 className="mb-4">Share it with the world!</h5>

                {
                    postEmbedCode != null || lockerEmbedCode != null ?
                        <h6 className="text-uppercase">Link</h6>
                        : <></>
                }
                <div className="clipboard mb-4">
                    <input type="text" disabled defaultValue={shareCode} id="myInput" onChange={() => null} />
                    <button className="btn" onClick={() => { navigator.clipboard.writeText(shareCode); setCopiedText(true); handleGoogleAnalytics4(); }}>{renderCopiedText()}</button>
                </div>

                {props.children}

                {
                    postEmbedCode != null ?
                        <>
                            <h6 className="text-uppercase">Blog Embed Code</h6>

                            <div className="clipboard mb-4">
                                <input type="text" disabled defaultValue={postEmbedCode} id="myInput" onChange={() => null} />
                                <button className="btn" onClick={() => { navigator.clipboard.writeText(postEmbedCode); setCopiedText2(true); }}>{renderCopiedText2()}</button>
                            </div>
                        </> : <></>
                }

                {
                    blogEmbedCode != null ?
                        <>
                            <h6 className="text-uppercase">Blog Embed Code</h6>

                            <div className="clipboard mb-4">
                                <input type="text" disabled defaultValue={blogEmbedCode} id="myInput" onChange={() => null} />
                                <button className="btn" onClick={() => { navigator.clipboard.writeText(blogEmbedCode); setCopiedText2(true); }}>{renderCopiedText2()}</button>
                            </div>
                        </> : <></>
                }

                {
                    lockerEmbedCode != null ?
                        <>
                            <h6 className="text-uppercase">Blog Embed Code</h6>

                            <div className="clipboard mb-4">
                                <input type="text" disabled defaultValue={lockerEmbedCode} id="myInput" onChange={() => null} />
                                <button className="btn" onClick={() => { navigator.clipboard.writeText(lockerEmbedCode); setCopiedText2(true); }}>{renderCopiedText2()}</button>
                            </div>
                        </> : <></>
                }

                {
                    productEmbedBrandCode != null ?
                        <>
                            <h6 className="text-uppercase">Blog Embed Code</h6>

                            <div className="clipboard mb-4">
                                <input type="text" disabled defaultValue={productEmbedBrandCode} id="myInput" onChange={() => null} />
                                <button className="btn" onClick={() => { navigator.clipboard.writeText(productEmbedBrandCode); setCopiedText3(true); }}>{renderCopiedText3()}</button>
                            </div>
                        </> : <></>
                }

                {
                    emailEmbedCode != null ?
                        <>
                            <h6 className="text-uppercase">Email Embed Code</h6>

                            <div className="clipboard mb-4">
                                <input type="text" disabled defaultValue={emailEmbedCode} id="myInput" onChange={() => null} />
                                <button className="btn" onClick={() => { navigator.clipboard.writeText(emailEmbedCode); setCopiedText3(true); }}>{renderCopiedText3()}</button>
                            </div>
                        </> : <></>
                }

                {
                    props.loggedInUser?.isAdmin && postEmbedBrandCode != null ?
                        <>
                            <h6 className="text-uppercase">ADMIN Embed Code</h6>

                            <div className="clipboard mb-4">
                                <input type="text" disabled defaultValue={postEmbedBrandCode} id="myInput" onChange={() => null} />
                                <button className="btn" onClick={() => { navigator.clipboard.writeText(postEmbedBrandCode); setCopiedText4(true); }}>{renderCopiedText4()}</button>
                            </div>
                        </> : <></>
                }

                {
                    props.loggedInUser?.isAdmin && lockerEmbedBrandCode != null ?
                        <>
                            <h6 className="text-uppercase">ADMIN Embed Code</h6>

                            <div className="clipboard mb-4">
                                <input type="text" disabled defaultValue={lockerEmbedBrandCode} id="myInput" onChange={() => null} />
                                <button className="btn" onClick={() => { navigator.clipboard.writeText(lockerEmbedBrandCode); setCopiedText4(true); }}>{renderCopiedText4()}</button>
                            </div>
                        </> : <></>
                }

                {
                    props.loggedInUser?.isAdmin && profileEmbedCode != null ?
                        <>
                            <h6 className="text-uppercase">ADMIN Embed Code</h6>

                            <div className="clipboard mb-4">
                                <input type="text" disabled defaultValue={profileEmbedCode} id="myInput" onChange={() => null} />
                                <button className="btn" onClick={() => { navigator.clipboard.writeText(profileEmbedCode); setCopiedText4(true); }}>{renderCopiedText4()}</button>
                            </div>
                        </> : <></>
                }

                {
                    merchantEmbedCode != null &&
                    <>
                        <h6 className="text-uppercase">Merchant Logo Embed Code</h6>
                        <div className="clipboard mb-4">
                            <input type="text" disabled defaultValue={merchantEmbedCode} onChange={() => null} />
                            <button className="btn" onClick={() => {
                                navigator.clipboard.writeText(merchantEmbedCode);
                                setCopiedText2(true);
                            }}>
                                {renderCopiedText2()}
                            </button>
                        </div>
                    </>
                }

                {!!(shareCode) ?
                    <>
                        <h6 className="text-uppercase">QR Code</h6>
                        {
                            qrImage ? 
                                <div style={{ marginBottom: "30px" }}>
                                <img src={qrImage} alt="QR Code" style={{ width: '128px', height: '128px' }} />
                            </div>
                            :
                            <></>
                        }
                        <div ref={qrCodeRefCallback} style={{ display: "none" }}>
                            <QRCodeCanvas
                                value={shareCode}
                                size={128}
                                level="H"
                                bgColor="#ffffff"
                                fgColor="#000000"
                                style={{
                                    marginBottom: '20px',
                                    pointerEvents: "auto",
                                    userSelect: "text",
                                    touchAction: "manipulation",
                                    WebkitUserSelect: "none",
                                }}
                                imageSettings={{
                                    src: `https://${window.location.host}/favicon.svg`,
                                    x: undefined,
                                    y: undefined,
                                    height: 128 * 0.2,
                                    width: 128 * 0.2,
                                    opacity: 1,
                                    excavate: true,
                                    style: {
                                        margin: "10px"
                                    }
                                }}
                            />
                        </div>
                    </>
                    :
                    <></>
                }



                <div className="social-share d-flex justify-content-center">
                    <TwitterIcon shareCode={props.shareCode} />
                    <FacebookIcon shareCode={props.shareCode} />
                    <MailIcon shareCode={props.shareCode} />
                    <MobileShare shareCode={props.shareCode} />
                </div>
            </div>

        </div>
    )
}

export default ShareBlock;